<template>
    <section class="section our-goal ptb_100">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <div class="col-12 col-lg-6">
                    <div class="goal-content section-heading text-center text-lg-left pr-md-4 mb-0">
                        <h3>{{$t('contact.phnompenh')}}</h3><br>
                            <ul>
                                <li class="py-2"><a class="text-black-50"><i class="fas fa-home"></i>   {{$t('contact.phnompenh')}}<br> {{$t('contact.addr_1')}}<br>{{$t('contact.addr_2')}}<br>{{$t('contact.addr_3')}}<br>{{$t('contact.addr_4')}}</a></li>
                                <li class="py-2"><a class="text-black-50" href="tel:+85510225044" ><i class="fas fa-phone-alt"></i> +855 (0)10 22 50 44</a></li>
                            </ul>

                    </div>
                </div>
         
            </div>
        </div>

    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>